import { styled } from '@mui/material';

import { Typography } from '../../atoms/Typography';

export const StyledTypography = styled(Typography)`
  padding: 3px !important;
`;